
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SalesOrderLineItemInformation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderLine"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SalesOrderLineInput"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"commonRecord"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerInput"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"salesOrderLineItemInformation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"salesOrderLine"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderLine"}}},{"kind":"Argument","name":{"kind":"Name","value":"customer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"commonRecord"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"level"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"freeStock"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"onOrder"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"outstanding"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"awaitingDispatch"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inProduction"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"makeable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"orderQuantityMinimum"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"orderQuantityIncrement"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastPriceUnitQuantity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastPriceUnitDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastPriceOrderNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastPriceOrderId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastPriceDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastPriceOrderQuantity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastGrossPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastDiscountPercentage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allocated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"leadTimeDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"returned"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"generated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minimumLevel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maximumLevel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"optimumLevel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"warehouseIsExcludeFromGeneralFreeStock"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"itemUsage"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"freeStockAvailability"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"averageForPeriod"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalUsage"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":815}};
    doc.loc.source = {"body":"query SalesOrderLineItemInformation($orderLine: SalesOrderLineInput, $commonRecord: CustomerInput) {\n  data: salesOrderLineItemInformation(salesOrderLine: $orderLine, customer: $commonRecord) {\n    message\n    level\n    freeStock\n    onOrder\n    outstanding\n    awaitingDispatch\n    inProduction\n    makeable\n    orderQuantityMinimum\n    orderQuantityIncrement\n    lastPrice\n    lastPriceUnitQuantity\n    lastPriceUnitDescription\n    lastPriceOrderNumber\n    lastPriceOrderId\n    lastPriceDate\n    lastPriceOrderQuantity\n    lastGrossPrice\n    lastDiscountPercentage\n    allocated\n    leadTimeDays\n    returned\n    generated\n    minimumLevel\n    maximumLevel\n    optimumLevel\n    warehouseIsExcludeFromGeneralFreeStock\n    itemUsage {\n      freeStockAvailability\n      averageForPeriod\n      totalUsage\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["SalesOrderLineItemInformation"] = oneQuery(doc, "SalesOrderLineItemInformation");
        
